var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,{tag:"component"},[_vm._l((_vm.allSlotNames),function(slotName){return [(_vm.activeSlotNames.includes(slotName))?_vm._t(slotName):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }